export const BLESSNET_API_URL = process.env.BLESSNET_BASE_URL
